var map = {
	"./8secondz.png": 9749,
	"./bartini.png": 7015,
	"./cabbagetreelandscape.png": 6250,
	"./cactus.png": 6074,
	"./cactuscan.png": 394,
	"./penncenterforneuroengineeringandtherapeutics.png": 5138,
	"./pennmedicine.png": 9738,
	"./pennneurodegenerationgenomicscenter.png": 5580,
	"./pennneurodegenerationgenomicscenter1.png": 1113,
	"./psykinetic.png": 1574,
	"./uipath.png": 344,
	"./uipath1.png": 8377,
	"./uipath2.png": 9361,
	"./uipath3.png": 2308,
	"./uipath5.png": 6249
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1165;